import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "prod",
    aws_cognito_region: "ap-southeast-2",
    aws_cognito_identity_pool_id: "ap-southeast-2:259b1ca2-ce4c-40eb-af42-3e9590bfc075",
    aws_user_pools_id: "ap-southeast-2_C0ymhwxHU",
    aws_user_pools_web_client_id: "5ao43mauhinf8af0mg09h020ik",
    Auth: {
      identityPoolId: "ap-southeast-2:259b1ca2-ce4c-40eb-af42-3e9590bfc075",
      region: "ap-southeast-2",
      userPoolId: "ap-southeast-2_C0ymhwxHU",
      userPoolWebClientId: "5ao43mauhinf8af0mg09h020ik",
    },
    oauth: {
      domain: "whs-safer-prod-au.auth.ap-southeast-2.amazoncognito.com",
      redirectSignIn: "https://prod.au.safer.whs.amazon.dev",
      redirectSignOut: "https://prod.au.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };
  Auth.configure(config);
}
